import { render, staticRenderFns } from "./ContactPersonCard.vue?vue&type=template&id=169813e2"
import script from "./ContactPersonCard.vue?vue&type=script&lang=js"
export * from "./ContactPersonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports